<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>ประวัติรายการสั่งสินค้า</strong></v-card-title>
          </v-layout>
          <br />
        <v-layout row wrap justify-center align-end>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>รหัสร้านค้า</strong></p>
                <v-text-field v-model="username_search" outlined clearable dense v-on:input="orderfilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อ-สกุล</strong></p>
                <v-text-field v-model="name_search" outlined clearable dense v-on:input="orderfilterfunction()" color="pink lighten-3"></v-text-field >
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5 v-for="(searchitem, i) in searchitems" :key="i">
                  <p style="color:#4C4C4C; font-size:90%;"><strong>{{searchitem.text}}</strong></p>
                  <v-combobox
                    v-model="searchitem.model"
                    :items="searchitem.items"
                    :item-text="searchitem.itemtext"
                    :item-value="searchitem.itemtext"
                    :return-object="false"
                    hide-selected
                    outlined
                    clearable
                    dense
                    multiple
                    persistent-hint
                    small-chips
                    v-on:input="orderfilterfunction()"
                    color="pink lighten-3"
                  ></v-combobox>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>วันที่สั่งซื้อ</strong></p>
                <VueCtkDateTimePicker color="#F06292" :no-value-to-custom-elem="true" v-model="dateorderpicker" only-date range v-on:input="daterangefunction(dateorderpicker, 'order')">
                  <v-text-field v-model="dateorderview" outlined dense color="pink lighten-3" readonly clearable v-on:input="orderfilterfunction()"></v-text-field>
                </VueCtkDateTimePicker>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>วันที่จัดส่ง</strong></p>
                <VueCtkDateTimePicker color="#F06292" :no-value-to-custom-elem="true" v-model="datedeliverypicker" only-date range v-on:input="daterangefunction(datedeliverypicker, 'delivery')">
                  <v-text-field v-model="datedeliveryview" outlined dense color="pink lighten-3" readonly clearable v-on:input="orderfilterfunction()"></v-text-field>
                </VueCtkDateTimePicker>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>เลขที่เอกสาร</strong></p>
                <v-text-field v-model="orderno_search" outlined clearable dense v-on:input="orderfilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
            </v-layout>
            <br />
          <v-data-table
            :headers="headers"
            :items="orderdatas"
            :items-per-page="10"
            class="elevation-3"
            :loading="loading"
            :server-items-length="datalength"
            @update:page="pagechange"
            @update:items-per-page="itempagechange"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="openorderdetail(item._id)">{{ item.order_no }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.username }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.name }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.address }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.order_date_th }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.tel }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.delivery_date_th }}</td>
                  <td @click="openorderdetail(item._id)">
                    <v-chip
                      :color="getColor(item.order_status)"
                      text-color="white"
                    >{{ item.order_status_th }}
                    </v-chip>
                  </td>
                  <td @click="openorderdetail(item._id)">
                    <v-chip
                      :color="getColor(item.payment_status)"
                      outlined
                    >{{ item.payment_status_th }}
                    </v-chip>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        </v-card>
      </v-flex>
      <Orderdetailmodal />
    </v-layout>
  </v-container>
</template>

<script>
import Orderdetailmodal from '@/components/Orderdetailmodal'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import moment from 'moment'
moment.locale('th')
export default {
  components: {
    Orderdetailmodal
  },
  data: () => ({
    headers: [
      { text: 'เลขที่เอกสาร', align: 'center', sortable: false, value: 'order_no' },
      { text: 'รหัสร้านค้า', align: 'center', sortable: false, value: 'username' },
      { text: 'ชื่อ-สกุล', align: 'center', sortable: false, value: 'name' },
      { text: 'ที่อยู่', align: 'center', sortable: false, value: 'address' },
      { text: 'วันที่สั่ง', align: 'center', sortable: false, value: 'order_date_th' },
      { text: 'เบอร์โทร', align: 'center', sortable: false, value: 'tel' },
      { text: 'จัดส่งวันที่', align: 'center', sortable: false, value: 'delivery_date_th' },
      { text: 'สถานะ', align: 'center', sortable: false, value: 'order_status' },
      { text: 'การชำระเงิน', align: 'center', sortable: false, value: 'payment_status' }
    ],
    orderdatas: [],
    orderdata_view: [],
    orderno_search: '',
    name_search: '',
    username_search: '',
    searchitems: [
      { text: 'เจ้าหน้าที่ผู้ดูแล', items: [], itemtext: 'adminref_name', model: [] },
      { text: 'สถานะ', items: ['จัดส่งสำเร็จ', 'จัดส่งไม่สำเร็จ', 'ไม่อนุมัติ'], itemtext: 'order_status_th', model: [] },
      { text: 'การชำระเงิน', items: ['อนุมัติ', 'ไม่อนุมัติ', 'ไม่ต้องชำระ'], itemtext: 'payment_status_th', model: [] }
    ],
    loading: false,
    page: 1,
    itempage: 10,
    dateorderpicker: '',
    dateorderview: '',
    datedeliverypicker: '',
    datedeliveryview: '',
    datalength: 0
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin' || this.$cookies.get('status') === 'admin') {
        this.date_now = (new Date()).toISOString().split('T')[0]
        this.month = `${(new Date()).toISOString().split('-')[0]}-${(new Date()).toISOString().split('-')[1]}`
        this.getsalename()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async pagechange (p) {
      this.page = p
      await this.getdata()
    },
    async itempagechange (itp) {
      this.itempage = itp
      await this.getdata()
    },
    getColor (status) {
      if (status === '00') return 'info'
      else if (status === '01') return 'success'
      else if (status === '02') return '#DD4B39'
      else if (status === '10') return '#52B9EB'
      else if (status === '11') return '#F7BA38'
      else if (status === '12') return '#388E3C'
      else if (status === '13') return '#F23B22'
      else if (status === '0') return 'info'
      else if (status === '1') return 'warning'
      else if (status === '2') return 'success'
      else if (status === '3') return '#DD4B39'
      else if (status === '4') return '#000000'
    },
    changestatustocode (statusarr) {
      let result = statusarr.map(status => {
        let codestt = ''
        if (status === 'จัดส่งสำเร็จ') {
          codestt = '12'
        } else if (status === 'จัดส่งไม่สำเร็จ') {
          codestt = '13'
        } else if (status === 'ไม่อนุมัติ') {
          codestt = '02'
        } else if (status === 'อนุมัติ') {
          codestt = '2'
        } else if (status === 'ไม่อนุมัติ') {
          codestt = '3'
        } else if (status === 'ไม่ต้องชำระ') {
          codestt = '4'
        }
        return codestt
      })
      return result
    },
    async getsalename () {
      this.loading = true
      let { data } = await axios.get(`${process.env.VUE_APP_API}/user/getinfo/salename`, {
        headers: {
          Authorization: this.$cookies.get('token')
        }
      })
      this.searchitems[0].items = data
      await this.getdata()
    },
    async getdata () {
      try {
        this.loading = true
        let odstatus = this.searchitems[1].model.length !== 0 ? this.changestatustocode(this.searchitems[1].model) : ['02', '12', '13']
        let pmstatus = this.searchitems[2].model.length !== 0 ? this.changestatustocode(this.searchitems[2].model) : ['2', '3', '4']
        let salename = this.searchitems[0].model.length !== 0 ? this.searchitems[0].model : this.searchitems[0].items

        let { data } = await axios.post(`${process.env.VUE_APP_API}/order/get/all`, {
          orderno: this.orderno_search || '',
          orderstatus: odstatus,
          paymentstatus: pmstatus,
          customername: this.name_search || '',
          username: this.username_search || '',
          salename: salename,
          orderdate: this.dateorderview,
          deliverydate: this.datedeliveryview
        }, {
          headers: {
            Authorization: this.$cookies.get('token'),
            limit: this.itempage,
            skip: (Number(this.page) - 1) * Number(this.itempage)
          }
        })

        this.orderdatas = data.orderdata.filter(pd => (pd.order_status !== '00' && pd.order_status !== '01' && pd.order_status !== '10' && pd.order_status !== '11' && pd.payment_status !== '0' && pd.payment_status !== '1')).map((pd, index) => {
          pd.payment_status_th = pd.payment_status === '2' ? 'อนุมัติ' : pd.payment_status === '3' ? 'ไม่อนุมัติ' : pd.payment_status_th
          return {
            ...pd,
            order_date_th: moment(pd.order_date).format('ll'),
            delivery_date_th: pd.delivery_date ? moment(pd.delivery_date).format('ll') : ''
          }
        })
        this.datalength = Number(data.orderlength)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    openneworder () {
      this.$router.push('/orderdetail')
    },
    openorderdetail (id) {
      this.orderdetailmodal = true
      this.currentorderid = id || ''
      this.orderdetailmode = 1
    },
    daterangefunction (datepicker, mode) {
      if (mode === 'order') {
        this.dateorderview = `${datepicker.start.split(' ')[0]} ~ ${datepicker.end ? datepicker.end.split(' ')[0] : datepicker.start.split(' ')[0]}`
      } else if (mode === 'delivery') {
        this.datedeliveryview = `${datepicker.start.split(' ')[0]} ~ ${datepicker.end ? datepicker.end.split(' ')[0] : datepicker.start.split(' ')[0]}`
      }
      this.getdata()
    },
    orderfilterfunction () {
      this.page = 1
      this.getdata()
    }
  },
  computed: {
    orderdetailmodal: sync('orderdetailmodal'),
    currentorderid: sync('currentorderid'),
    orderdetailmode: sync('orderdetailmode')
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}

.v-data-table {
  font-family: 'Kanit';
}

td {
  max-width: 120px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>

<style>
.date-time-picker * {
  font-family: 'Kanit' !important;
}
</style>
